import React from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { NODE_COLORS } from '../../config/theme';
import TextEditorModal from './TextEditorModal';

export default function TemplateEditor({ open, onClose, selectedNode, availableVariables = [], onSave }) {
  return (
    <TextEditorModal
      open={open}
      onClose={onClose}
      title="Template Editor"
      nodeLabel={selectedNode?.data?.label}
      nodeColor={NODE_COLORS.TEMPLATE}
      nodeIcon={<DescriptionOutlinedIcon sx={{ fontSize: 16 }} />}
      value={selectedNode?.data?.template || ''}
      onSave={onSave}
      availableVariables={availableVariables}
      placeholder={"# Report Title\n\n## Summary\n\nWrite your template here using {{NodeName}} placeholders.\nEach placeholder will be replaced with the connected node's output at runtime."}
    />
  );
}
